import { gql } from '@apollo/client';

export const ContributorFragment = gql`
  fragment Contributor on Contributor {
    id
    name
  }
`;
